

<ion-content>
  <div  *ngIf="tempPermitState.checking"
  style="
  background-color:rgba(255, 255, 255, 0.85);
  position:fixed;
  width:100%;
  height:100%;
  top:0px;
  left:0px;
  z-index:1000;">
 <ion-grid style="height: 100%;">
  <ion-row style="height: 50%;">
    <ion-col style="text-align: center;">
      
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col style="text-align: center;">
      <ion-spinner color="secondary" name="circular"></ion-spinner>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col style="text-align: center;"> 
      <ion-item lines="none" style="--background:transparent !important;text-align: center;" class="paragraph-input-fields-bold">
        <ion-label class="ion-text-wrap">
          {{('keys.data.permits.temporary_permit_validating' | translate : {Default:'Please wait while we validate your Temporary Permit options.'}) || "Please wait while we validate your Temporary Permit options."}}
        </ion-label>
      </ion-item>
    </ion-col>
  </ion-row>
 </ion-grid>
   
</div>
<app-loading-spinner  *ngIf="!loaded"></app-loading-spinner>
        <ion-row>
          <ion-col>
            <ion-toolbar>
            <ion-buttons slot="end">
              <ion-button (click)="closeModal()" 
                ><ion-icon color="dark" name="close"></ion-icon
              ></ion-button>
            </ion-buttons>
          </ion-toolbar>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="loaded">
          <ion-col style="text-align: center;">
            <h2 class="subheader-regular">{{lot.LotName}}</h2>
          </ion-col>
        </ion-row>
<ion-grid *ngIf="loaded" class="single-col">
  <ion-row>
    <ion-col style="text-align: center">
      <h4>
        {{lot.Location}}
      </h4>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-card class="card-shadow-7">
        <ion-segment
                [(ngModel)]="permitType"
                (ionChange)="segmentChanged($event)"
                color="dark" style="--background:var(--Gray-300, #F2F2F2);"
              >
               
                <ion-segment-button  color="dark" style="--background:var(--Gray-300, #F2F2F2);"
                [disabled]="disableHourly" 
                value="hourly">
               
                  <ion-label>{{('keys.data.permits.temporary_hourly' |
                    translate : {Default:'Hourly'}) || 'Hourly' }}</ion-label>
                </ion-segment-button>
                <ion-segment-button [disabled]="disableDaily"  value="daily" color="dark" style="--background:var(--Gray-300, #F2F2F2);">
                  <ion-label>{{('keys.data.permits.temp_daily' |
                    translate : {Default:'Daily'}) || 'Daily' }}</ion-label>
                </ion-segment-button>
              </ion-segment>
              <div [ngSwitch]="permitType">
                <ng-container *ngSwitchCase="'hourly'">
                  <form novalidate [formGroup]="tempPermitFormHourly">
                    <ion-grid>
                      <ion-row>
                        <ion-col>
                          <ion-card class="card-shadow-3" *ngIf="(dataSRV.isAuthenticated | async ) == false"> 
                          <ion-item >
                            <ion-label >{{ ('keys.data.vehicles.plate' | translate : {Default:'Plate'}) ||
                              'Plate' }}:</ion-label>
                              <ion-input (ionChange)="plateChanged()" pattern="^[A-Za-z0-9']*$" maxlength="8"  formControlName="plate"  type="text"></ion-input>
                             
                          </ion-item>
                          
                        </ion-card>
                        
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="(dataSRV.isAuthenticated | async ) == true">
                        <ion-col>
                          <ion-card class="card-shadow-3">
                          <ion-item >
                            <ion-label>{{ ('keys.data.vehicles.vehicle' |
                              translate : {Default:'Vehicle'}) || 'Vehicle' }}:</ion-label>
                              <ion-select required  formControlName="vehicle"   
                              (ionChange)="vehiclesChanged()"
                                        [mode]="platformSRV.mode"
                                          placeholder="Select Vehicle"
                                          [interface]="platformSRV.interface"
                                          multiple="false"
                                          
                                        >
                                          <ion-select-option
                                            *ngFor="let v of vehicles"
                                            [value]="v.VehicleID"
                                            >{{ v.ColourName }} {{ v.Year }} {{ v.MakeName
                                            }} {{ v.Plate }}</ion-select-option
                                          >
                                          <ion-select-option [value]="guestVehicleID" *ngIf="dataSRV.settings.vehicles.guest_vehicle"
                                            ><ng-container *ngIf="dataSRV.user as user"
                                              >Guest Vehicle -- Guest of {{
                                                dataSRV.settings.userProfile.preferredName
                                              && user['preferredname'] ?
                                              user['pereferredname'] : user['firstName'] + '
                                              ' + user['lastName'] }}</ng-container
                                            ></ion-select-option
                                          >
                                        </ion-select>
                          </ion-item>
                        </ion-card>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="tempPermitFormHourly.value['vehicle']==guestVehicleID">
                        <ion-col>
                          <ion-card class="card-shadow-3">
                          <ion-item >
                            <ion-label >{{ ('keys.data.vehicles.plate' | translate : {Default:'Plate'}) ||
                              'Plate' }}:</ion-label>
                              <ion-input pattern="^[A-Za-z0-9']*$" maxlength="8"   formControlName="plate"  type="text" (ionChange)="plateChanged()"></ion-input>
                             
                          </ion-item>
                         
                        </ion-card>
                        
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col>
                          <ion-card class="card-shadow-3">
                          <ion-item>
                            <ion-label >{{ ('keys.data.permits.temporary_hours' |
                              translate : {Default:'Hours'}) || 'Hours' }}:</ion-label>
                              <ion-select  (ionChange)="hoursChanged()" required formControlName="hours"    multiple="false"  interface="popover" placeholder="Select duration">
                                <ion-select-option *ngFor="let hour of lot.lot_hourly_cost" [value]="hour.duration" >{{hour.duration}}</ion-select-option>
                              </ion-select>
                          </ion-item>
                        </ion-card>
                       
                        </ion-col>
                        
                      </ion-row>
                      <ion-row>
                        <ion-col style="text-align: center;">
                          <ion-button [disabled]="tempPermitFormHourly.invalid || (tempPermitFormHourly.value['vehicle']==guestVehicleID && tempPermitFormHourly.value['plate'].trim()=='')"  color="primary" (click)="hourlyChanged()" >{{ ('keys.data.permits.check_availability' |
                            translate : {Default:'Check availability'}) || 'Check availability' }}</ion-button>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </form>
                </ng-container>
                <ng-container *ngSwitchCase="'daily'">
                  <form novalidate [formGroup]="tempPermitFormDaily">
                    <ion-grid>
                      <ion-row *ngIf="(dataSRV.isAuthenticated | async ) == false">
                        <ion-col>
                          <ion-card class="card-shadow-3">
                          <ion-item >
                            <ion-label  >{{ ('keys.data.vehicles.plate' | translate : {Default:'Plate'}) ||
                              'Plate' }}:</ion-label>
                              <ion-input (ionChange)="plateChanged()" pattern="^[A-Za-z0-9']*$" maxlength="8"  formControlName="plate"  type="text"></ion-input>
                              
                          </ion-item>
                        </ion-card>
                        </ion-col>
                        </ion-row>
                        <ion-row *ngIf="(dataSRV.isAuthenticated | async ) == true">
                          <ion-col>
                            <ion-card class="card-shadow-3">
                              <ion-item >
                                <ion-label >{{ ('keys.data.vehicles.vehicle' |
                                  translate : {Default:'Vehicle'}) || 'Vehicle' }}:</ion-label>
                                  <ion-select required  formControlName="vehicle"   
                                  (ionChange)="vehiclesChanged()"
                                            [mode]="platformSRV.mode"
                                              placeholder="Select Vehicle"
                                              [interface]="platformSRV.interface"
                                              multiple="false"
                                              
                                            >
                                              <ion-select-option
                                                *ngFor="let v of vehicles"
                                                [value]="v.VehicleID"
                                                >{{ v.ColourName }} {{ v.Year }} {{ v.MakeName
                                                }} {{ v.Plate }}</ion-select-option
                                              >
                                              <ion-select-option [value]=guestVehicleID *ngIf="dataSRV.settings.vehicles.guest_vehicle"
                                                ><ng-container *ngIf="dataSRV.user as user"
                                                  >Guest Vehicle -- Guest of {{
                                                    dataSRV.settings.userProfile.preferredName
                                                  && user['preferredname'] ?
                                                  user['pereferredname'] : user['firstName'] + '
                                                  ' + user['lastName'] }}</ng-container
                                                ></ion-select-option
                                              >
                                            </ion-select>
                              </ion-item>
                            </ion-card>
                          </ion-col>
                        </ion-row>
                          
                      <ion-row *ngIf="tempPermitFormDaily.value['vehicle']==guestVehicleID">
                        <ion-col>
                          <ion-card class="card-shadow-3">
                          <ion-item >
                            <ion-label >{{ ('keys.data.vehicles.plate' | translate : {Default:'Plate'}) ||
                              'Plate' }}:</ion-label>
                              <ion-input (ionChange)="plateChanged()" pattern="^[A-Za-z0-9']*$" maxlength="8"    formControlName="plate"  type="text"></ion-input>
                             
                          </ion-item>
                        </ion-card>
                        
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col style="text-align: center;">
                          <ion-button [disabled]="tempPermitFormDaily.invalid || (tempPermitFormDaily.value['vehicle']==guestVehicleID && tempPermitFormDaily.value['plate'].trim()=='')"  color="primary" (click)="dailyChanged()" >{{ ('keys.data.permits.check_availability' |
                            translate : {Default:'Check availability'}) || 'Check availability' }}</ion-button>
                        </ion-col>
                      </ion-row>
                      
                    </ion-grid>
                  </form>
                </ng-container>
              </div>
              
      </ion-card>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
    
        <ion-grid>
          <ion-row>
            <ion-col size="12" *ngIf="!tempPermitState.valid && !tempPermitState.checking">
              
              <ion-card
              class="ion-text-wrap card-shadow-3"
              >
              <ion-item lines="none" class="paragraph-regular">
                <ion-label>{{('keys.data.permits.temporary_please_fill_in_all_details' | translate : {Default:'Please fill in all details to purchase a Temporary Permit.'}) || "Please fill in all details to purchase a Temporary Permit."}}</ion-label>
            </ion-item>
            </ion-card>
              
            </ion-col>
            <ion-col size="12" *ngIf="tempPermitState.valid && permitType=='hourly'">
             
                <ion-grid>
                  <ion-row>
                    <ion-col>
                      <ion-item lines="none" class="paragraph-input-fields-regular">
                        <ion-label>{{('keys.data.common.date' | translate : {Default:'Date'}) || "Date"}}</ion-label>
                        <ion-label slot="end"
                          >{{ permitDetails['startDateObject'] |
                          date:dataSRV.settings['system']['datemask']}}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>
                      <ion-item lines="none" class="paragraph-input-fields-regular">
                        <ion-label>{{('keys.data.permits.temporary_start_time' |
                          translate : {Default:'Start Time'}) || 'Start Time' }}</ion-label>
                        <ion-label slot="end"
                          >{{ permitDetails['startTime']
                          }}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>
                      <ion-item lines="none" class="paragraph-input-fields-regular">
                        <ion-label>{{('keys.data.permits.temporary_end_time' |
                          translate : {Default:'End Time'}) || 'End Time' }}</ion-label>
                        <ion-label slot="end"
                          >{{ permitDetails['endTime']
                          }}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>
                      <ion-item lines="none" class="paragraph-input-fields-regular">
                        <ion-label>{{('keys.data.common.subtotal' |
                          translate : {Default:'Subtotal'}) || 'Subtotal' }}</ion-label>
                        <ion-label slot="end"
                          >{{ permitDetails['rateMoney']
                          }}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  <ion-row *ngFor="let tax of permitDetails['taxes']" >
                    <ion-col *ngIf="tax?.amount">
                      <ion-item  lines="none" class="paragraph-input-fields-regular">
                        <ion-label>{{tax?.label}} {{tax?.percentage | round:3}}%</ion-label>
                        <ion-label slot="end"
                          >{{ tax?.amount | currency
                          }}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>
                      <ion-item lines="none" class="paragraph-input-fields-bold">
                        <ion-label>{{('keys.data.common.total_owing' |
                          translate : {Default:'Total Owing'}) || 'Total Owing' }}</ion-label>
                        <ion-label slot="end"
                          >{{ permitDetails['totalMoney']
                          }}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  
                </ion-grid>

                <!-- Hourly Permit Output End -->
             
            </ion-col>
            <ion-col size="12" *ngIf="tempPermitState.valid && permitType=='daily'">
              
                <ion-grid>
                  
                  <ion-row>
                    <ion-col>
                      <ion-item lines="none" class="paragraph-input-fields-regular">
                        <ion-label>{{('keys.data.permits.start_date' |
                          translate : {Default:'Start Date'}) || 'Start Date' }}:</ion-label>
                        <ion-label slot="end"
                          >{{ permitDetails['startDateObject'] |
                          date:dataSRV.settings['system']['datemask']
                          }}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>
                      <ion-item lines="none" class="paragraph-input-fields-regular">
                        <ion-label>{{('keys.data.permits.end_date' |
                          translate : {Default:'End Date'}) || 'End Date' }}:</ion-label>
                        <ion-label slot="end"
                          >{{ permitDetails['endDateObject'] |
                          date:dataSRV.settings['system']['datemask']
                          }}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>
                      <ion-item lines="none" class="paragraph-input-fields-regular">
                        <ion-label>{{('keys.data.common.subtotal' |
                          translate : {Default:'Subtotal'}) || 'Subtotal' }}:</ion-label>
                        <ion-label slot="end"
                          >{{ permitDetails['rateMoney']
                          }}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>
                      <ion-item lines="none" class="paragraph-input-fields-regular">
                        <ion-label>{{('keys.data.common.taxes' |
                          translate : {Default:'Taxes'}) || 'Taxes' }}:</ion-label>
                        <ion-label slot="end"
                          >{{ permitDetails['taxesMoney']
                          }}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>
                      <ion-item lines="none" class="paragraph-input-fields-bold">
                        <ion-label>{{('keys.data.common.total_owing' |
                          translate : {Default:'Total Owing'}) || 'Total Owing' }}:</ion-label>
                        <ion-label slot="end"
                          >{{ permitDetails['totalMoney']
                          }}</ion-label
                        >
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  
                </ion-grid>

                <!-- Hourly Permit Output End -->
              
            </ion-col>
          </ion-row>
        </ion-grid>
     
    </ion-col>
  </ion-row>
</ion-grid>
</ion-content>
<ion-footer >
  <ion-toolbar *ngIf="tempPermitState.valid" >
    <ion-grid class="single-col">
      <ion-row *ngIf="permitDetails['total']>0">
        <ion-col  >
          <ion-item  >
           <ion-label position="stacked">{{ ('keys.data.payments.select_payment_type' |
            translate : {Default:'Select Payment Type'}) || 'Select Payment Type' }}</ion-label>
            <ion-select
            placeholder="{{ ('keys.data.payments.payment_method' |
            translate : {Default:'Payment Method'}) || 'Payment Method' }}:"
              [(ngModel)]="payType"
              interface="popover"
            >
              <ion-select-option
                *ngFor="let paymentType of paymentTypes"
                [value]="paymentType"
                >{{paymentType['PaymentTypeName']}}</ion-select-option
              >
            </ion-select>
          </ion-item>
        </ion-col>
       
      </ion-row>
      <ion-row *ngIf="permitDetails['total']==0">
        <ion-col style="text-align: center;">
          <ion-title style="font-weight: bold">
            {{ ('keys.data.common.zero_dollar_item' |
            translate : {Default:'Zero Dollar Item'}) || 'Zero Dollar Item' }}
          </ion-title>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="8" offset="2">
          <ion-button (click)="proceed()" [disabled]="payType=='' && permitDetails['total']>0" expand="block" color="primary">{{ ('keys.data.payments.make_payment' |
            translate : {Default:'Make Payment'}) || 'Make Payment' }}</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
